<template>
    <div class="goods-item" @click="toDetail(data)">
        <div class="goods-img-info" >
            <div class="img-box">
                <img class="goods-img" v-lazy="$publicFn.optimizationImage(data.picUrl || data.pic, {size: {w:266,h:200}})">
                <div class="goods-institution van-ellipsis" v-if="data.branchName">来源：{{data.branchName}}</div>
            </div>
            <div class="goods-info">
                <div>
                    <div class="goods-title van-ellipsis">{{data.name}}</div>
                    <div class="goods-desc van-multi-ellipsis--l2" v-if="data.recommendReason || data.goodsSellingPoint">{{data.recommendReason || data.goodsSellingPoint}}</div>
                </div>
                <div class="list-item-box" v-if="data.teachingForm">
                    <div class="list-item">
                        <p class="tag-title"><span>授课形式</span></p>
                        <p class="tag-list">
                            <span class="tag-item">{{onGetTeachingForm(data.teachingForm)}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="goods-price-btns">
            <div class="price-num">
                <span v-if="data.priceType == 0 || data.priceType == 2">
                    <template v-if="data.salePrice == 0">
                        免费
                    </template>
                    <template v-else>
                        <span class="unit">¥</span>{{ data.salePrice}}
                    </template>
                </span>
                <span v-else-if="data.priceType == 1">免费</span>
                <div class="line-price" v-if="[0,1,2].includes(data.priceType) && data.basePrice">原价:{{data.basePrice || 0}}</div>
                <span v-else-if="data.priceType == 3">¥{{ data.salePrice }}-{{ data.highestSalePrice }}</span> 
            </div>
            <div class="goods-btns">
                <div class="btn-item free-btn" v-if="data.tryWatch == 1" @click.stop="toDetail(data, 1)">免费试看</div>
                <div class="btn-item qus-btn" v-if="onShowBtn(data,1)"
                    @click.stop="handleServe()">立即咨询</div>
                <div class="btn-item buy-btn" v-if="onShowBtn(data,2)"
                    @click.stop="toDetail(data)">立即购买</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'goodsItem',
    props: {
        data: {
            type: Object,
            default: ()=>{},
        },
    },
    methods: {
        formatNum(val) {
            if(val > 10000) {
                return `${parseFloat((val/10000).toFixed(1))}w+笔`
            }
            return `${val || 0}笔`
        },
        onGetTeachingForm(list) {
            const mapList = {
                1: '面授',
                2: '录播',
                3: '直播'
            }
            return list.map(v=> mapList[v]).join('、');
        },
        onShowBtn({transformationGuidanceList},value) {
            return transformationGuidanceList && transformationGuidanceList.includes(value)
        },
        handleServe() {
            if (localStorage.getItem('token')) {
                window.qimoChatClick();
            } else {
                this.$router.push({
                    path: '/login',
                    query: {
                        name: '/couponGoodsList',
                        ...this.$route.query,
                        consult: 1,
                    }
                })
            }
        },
        toDetail({goodsId,id,goodsKind}, autoplay = 0) {
            this.$router.push({
                path: '/goodsDetail',
                query: {
                    goodsId: goodsId || id,
                    goodsKind: goodsKind,
                    visit_referrer: 'couponGoodsList',
                    isH5: 1,
                    autoplay,
                }
            })
        },
        // async handleStationPage(branchId) {
        //     let url = await this.$publicFn.getSaasBranchDomain(branchId);
        //     if(this.$isapp){
        //         this.$WDJSBridge.useNewPage(
        //             JSON.stringify({
        //                 url: `${url}/stationPage`,
        //                 pageName: "stationPage",
        //             })
        //         );
        //     } else {
        //         window.location.href = `${url}/stationPage`
        //     }
        // }
    },
}
</script>

<style lang="less" scoped>
    .goods-item {
        background-color: #fff;
        border-radius: 16px;
        padding: 30px 16px 24px 16px;
        .goods-img-info {
            margin-bottom: 24px;
            display: flex;
            .img-box {
                position: relative;
                width: 266px;
                height: 200px;
            }
            .goods-img {
                width: 100%;
                height: 100%;
                border-radius: 16px;
            }
            .goods-institution {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 40px;
                line-height: 40px;
                background-color: rgba(0,0,0,0.8);
                font-size: 20px;
                color: #fff;
                text-align: center;
                border-radius: 0 0 16px 16px;
                padding: 0 5px;
                box-sizing: border-box;
            }
        }
        
        .goods-info {
            padding: 0 16px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 400px;
            box-sizing: border-box;
        }
        .goods-title {
            font-size: 30px;
            font-weight: 500;
            color: #333333;
            line-height: 38px;
            margin-bottom: 10px;
            width: 100%;
            
        }
        .goods-desc {
            color: #999;
            font-size: 24px;
            line-height: 32px;
            word-break: break-all;
        }
        .list-item {
            display: inline-flex;
            height: 40px;
            font-size: 24px;
            border: 1px solid #E5EEFE;
            border-radius: 8px;
            padding-right: 40px;

            .tag-title {
                background-color: #E5EEFE;
                color: #0661FE;
                border-radius: 8px 0 0 8px;
                padding: 0 10px;
                height: 100%;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                min-width: 120px;
                margin-right: 10px;
                span {
                    flex: 1;
                    text-align: justify;
                    height: 100%;
                    overflow-y: hidden;
                    line-height: 40px;
                    &:after {
                        content: '';
                        display: inline-block;
                        width: 100%;
                    }
                }
            }

            .tag-list {
                height: 100%;
                margin-bottom: 0;
                display: flex;
                flex: 1;
                flex-wrap: wrap;
                align-items: center
            }
            .tag-item {
                background-color: transparent;
                font-size: 24px;
                color: #333;
                display: inline-block;
            }
        }

        .goods-price-btns{
            display: flex;
            justify-content: space-between;
            min-height: 76px;
            align-items: center;
            .price-num {
                font-size: 36px;
                color: #FF2F2F;
                font-weight: 600;
                .unt {
                    font-size: 20px;
                }
                .line-price {
                    color: #999;
                    font-size: 24px;
                    text-decoration: line-through;
                    font-weight: 400;
                    margin-bottom: 0;
                }
            }
            .goods-btns {
                display: flex;
                flex: 1;
                justify-content: flex-end;
                .btn-item {
                    margin-left: 24px;
                    height: 48px;
                    min-width: 148px;
                    text-align: center;
                    border-radius: 26px;
                    font-size: 24px;
                    line-height: 48px;
                    &:first-child {
                        margin-left: 0;
                    }
                }
                .btnColor(@text,@border,@bg) {
                    color: @text;
                    border: 1px solid @border;
                    background-color: @bg;
                }
                .free-btn {
                    .btnColor(#025EFE,#025EFE, #fff)
                }
                .qus-btn {
                    .btnColor(#666,#666, #fff)
                }
                .buy-btn {
                    .btnColor(#fff,#FF2F2F, #FF2F2F)
                }
            }
        }
    }
</style>